import { fetchToggleOfferSlider } from '../../repositories/countryside-contracts-admin/v1/toggle-offer-slider';
import { IThunkActionCreator } from '../';
import { trackToggleProjectListVisibility } from '../../utils/tracking/project';

export function toggleProjectListSlider(isHidden: boolean): IThunkActionCreator {
  return async (dispatch, getState, { httpApi, logger }) => {
    try {
      trackToggleProjectListVisibility(isHidden);

      await fetchToggleOfferSlider({
        httpApi,
        parameters: { isHidden },
      });
    } catch (e) {
      logger.error(e);
    }
  };
}
